import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatOptionModule } from '@angular/material/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'

import { TranslateModule } from '@ngx-translate/core'

import { IPerformanceQuarter } from '~/core/models'

@Component({
  selector: 'app-performance-period',
  templateUrl: './performance-period.component.html',
  styleUrl: './performance-period.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslateModule, MatSelectModule, MatOptionModule, MatFormFieldModule],
})
export class PerformancePeriodComponent {
  readonly queuerList = input<IPerformanceQuarter[]>([])
  readonly queuer = input<IPerformanceQuarter | null>()
  readonly changeQueuer = output<IPerformanceQuarter>()

  showWinRate = true
}
